import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-qrmodal',
  standalone: true,
  imports: [MatDialogContent, MatDialogActions, CommonModule, MatIconModule, FontAwesomeModule, TranslateModule],
  templateUrl: './qrmodal.component.html',
  styleUrl: './qrmodal.component.scss'
})
export class QrmodalComponent {
  faCalendarAlt = faCalendarAlt;
  isLoadingWallet = false;

  readonly isIos: boolean;
  readonly isAndroid: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title: string; qrCode: string; eventDate: string; visitorName?: string; qrId?: number },
    private dialogRef: MatDialogRef<QrmodalComponent>,
    private http: HttpClient,
  ) {
    const ua = navigator.userAgent;
    this.isIos = /iPhone|iPad|iPod/i.test(ua);
    this.isAndroid = /Android/i.test(ua);
  }

  closeModal() {
    this.dialogRef.close();
  }

  addToAppleWallet() {
    if (!this.data.qrId) return;
    this.isLoadingWallet = true;
    const base = environment.apiUrl.replace(/\/$/, '');
    const url = `${base}/qrs/${this.data.qrId}/apple-wallet`;

    // Fetch the pass as blob so the auth interceptor sends the JWT
    this.http.get(url, { responseType: 'blob' }).subscribe({
      next: (blob) => {
        this.isLoadingWallet = false;
        const blobUrl = URL.createObjectURL(new Blob([blob], { type: 'application/vnd.apple.pkpass' }));
        // On iOS, navigating to a pkpass URL triggers the native "Add to Wallet" sheet
        // On other platforms it falls back to a direct open
        window.location.href = blobUrl;
      },
      error: () => {
        this.isLoadingWallet = false;
      },
    });
  }

  addToGoogleWallet() {
    if (!this.data.qrId) return;
    this.isLoadingWallet = true;
    const base = environment.apiUrl.replace(/\/$/, '');
    const url = `${base}/qrs/${this.data.qrId}/google-wallet`;
    this.http.get<{ url: string }>(url).subscribe({
      next: ({ url: saveUrl }) => {
        this.isLoadingWallet = false;
        window.open(saveUrl, '_blank');
      },
      error: () => {
        this.isLoadingWallet = false;
      },
    });
  }
}
